import { getHttpStatus } from './httpErrorUtils';

/**
 * Counts describing how an episode date/status edit affects existing records.
 * Mirrors the backend EpisodeEditImpact payload returned inside a 409 response.
 */
export type EpisodeEditImpactWarnings = {
  visits_out_of_window: number;
  orders_out_of_window: number;
  authorizations_out_of_window: number;
  billing_cycles_to_void: number;
  deactivation_final_cycle_possible: boolean;
};

/**
 * The 409 impact payload is a structured `detail` object; parse it with typed
 * handling rather than getBusinessErrorMessage, which would flatten the counts.
 * Returns null when the error is not the episode-edit impact 409.
 */
export const parseEpisodeEditImpactWarnings = (
  error: unknown
): EpisodeEditImpactWarnings | null => {
  if (getHttpStatus(error) !== 409) {
    return null;
  }
  const detail = (
    error as { response?: { data?: { detail?: unknown } } } | null
  )?.response?.data?.detail;
  if (
    detail &&
    typeof detail === 'object' &&
    (detail as { code?: unknown }).code === 'episode_edit_impact'
  ) {
    const warnings = (detail as { warnings?: unknown }).warnings;
    if (warnings && typeof warnings === 'object') {
      return warnings as EpisodeEditImpactWarnings;
    }
  }
  return null;
};
